var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 3.75C12.1275 3.75 12.5775 3.9975 12.8475 4.38L16.125 9L12.8475 13.62C12.5775 14.0025 12.1275 14.25 11.625 14.25L3.375 14.2425C2.55 14.2425 1.875 13.575 1.875 12.75V5.25C1.875 4.425 2.55 3.7575 3.375 3.7575L11.625 3.75ZM3.375 12.75H11.625L14.2875 9L11.625 5.25H3.375V12.75Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldname);
export default __webpack_public_path__ + "static/media/fieldname.275e3ae2a8538cc67a7a98fbdb0a0aa8.svg";
export { ForwardRef as ReactComponent };